<template>
  <div class="run-page">
    <RunInit
      ref="runInit"
      v-show="!haveInit"
      :utcOffset="$store.state.pods.selectedUtcOffset"
    />
    <RunContinue
      ref="runContinue"
      v-show="haveInit"
      :utcOffset="$store.state.pods.selectedUtcOffset"
    />
  </div>
</template>

<script>
import RunInit from '@/components/products/characterisation/RunInit'
import RunContinue from '@/components/products/characterisation/RunContinue'
export default {
  data() {
    return {
      haveInit: false
    }
  },
  components: {
    RunInit,
    RunContinue
  }
}
</script>

<style lang="scss" scoped>
.run-page {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
